import { MapPin, Phone, Mail } from 'lucide-react';

import { Button } from '@/components/ui/button';

const PHONE_NUMBER = '+919633210606';
const EMAIL = 'friendsonroadcab@email.com';

const ContactSection = () => {
  return (
    <section id="contact" className="py-16 md:py-24 section-gradient-light">


      <div className="container px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12">
          <span className="inline-block text-xs sm:text-sm font-bold text-primary uppercase tracking-widest mb-3 animate-fade-up">
            GET IN TOUCH
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 animate-fade-up stagger-1">
            Contact <span className="gradient-text-animated">Us</span>
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base sm:text-lg animate-fade-up stagger-2">
            We're always ready to help. Reach out anytime!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-7xl mx-auto items-start">
          {/* Contact Info */}
          <div className="space-y-5 lg:space-y-6">
            {/* Address */}
            <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6 flex items-start gap-4 border border-gray-100 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 card-shine group animate-fade-up">
              <div className="blue-icon-circle shrink-0 w-12 h-12 sm:w-14 sm:h-14 icon-hover group-hover:animate-glow-pulse">
                <MapPin className="h-5 w-5 sm:h-6 sm:w-6 text-black" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg group-hover:text-primary transition-colors duration-300">Our Location</h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Kannur District<br />
                  Kerala, India - 670005
                </p>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6 flex items-start gap-4 border border-gray-100 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 card-shine group animate-fade-up stagger-1">
              <div className="blue-icon-circle shrink-0 w-12 h-12 sm:w-14 sm:h-14 icon-hover group-hover:animate-glow-pulse">
                <Phone className="h-5 w-5 sm:h-6 sm:w-6 text-black" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg group-hover:text-primary transition-colors duration-300">Phone</h3>
                <a
                  href={`tel:${PHONE_NUMBER}`}
                  className="text-gray-600 hover:text-primary transition-colors text-base sm:text-lg font-medium"
                >
                  {PHONE_NUMBER}
                </a>
                <p className="text-xs sm:text-sm text-gray-500 mt-1">
                  Available 24/7
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6 flex items-start gap-4 border border-gray-100 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 card-shine group animate-fade-up stagger-2">
              <div className="blue-icon-circle shrink-0 w-12 h-12 sm:w-14 sm:h-14 icon-hover group-hover:animate-glow-pulse">
                <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-black" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg group-hover:text-primary transition-colors duration-300">Email</h3>
                <a
                  href={`mailto:${EMAIL}`}
                  className="text-gray-600 hover:text-primary transition-colors text-sm sm:text-base break-all"
                >
                  {EMAIL}
                </a>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <Button
              variant="whatsapp"
              size="lg"
              className="w-full text-base sm:text-lg py-5 sm:py-6 btn-premium touch-target-lg animate-fade-up stagger-3"
              asChild
            >
              <a
                href={`https://wa.me/${PHONE_NUMBER.replace(/\+/g, '')}?text=${encodeURIComponent(
                  'Hello, I want to book a taxi from Friends On Road Cab, Kannur.'
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp
              </a>
            </Button>
          </div>

          {/* Google Map */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden h-[350px] sm:h-[400px] lg:h-auto border border-gray-100 animate-fade-up stagger-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31147.69647669651!2d75.35!3d11.87!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba43e7c7b5c8b1d%3A0x8c7c3d3e3c3c3c3c!2sKannur%2C%20Kerala!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '350px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Friends On Road Cab Location"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
